// OSS 上导出评论附件的存储路径（相对 storage 根 + prefix）：
export const buildOssCommentAttachmentPath = (): string => `/comment_attachment`
